/* eslint-disable @typescript-eslint/no-unused-vars */
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { SVCTable } from './SVCTable';
import { SVCBaseSelect } from './SVCBaseSelect';
import SVCItemForm from './SVCltemForm';
import { useMount, useUnmount } from 'ahooks';
import { useOrgId } from 'hooks/useOrg';
import { isPlatformOrg } from 'domains/orgDomain';
import { useEffect } from 'react';
import SVCSpecItemForm from './SVCSpecItemForm';
import { SVCSpecBaseSelect } from './SVCSpecBaseSelect';

const SVCAdmin = () => {
  const dispatch = useAppDispatch();
  const formVisible = useAppSelector(
    (state) =>
      state.svc.creatingSvc ||
      state.svc.creatingSvcSpec ||
      state.svc.viewingSvc ||
      state.svc.viewingSvcSpec
  );
  const { creatingSvc, creatingSvcSpec, viewingSvc, viewingSvcSpec } =
    useAppSelector((state) => state.svc);

  const filterObj = useAppSelector((state) => state.svc.filterObj);

  const orgId = useOrgId();
  const isBaseOrg = isPlatformOrg({ id: orgId });

  useMount(() => {
    dispatch.svc.getSVCTypes();
  });

  useUnmount(() => {
    dispatch.svc.reset();
    dispatch.app.setState({
      filterForceHidden: false,
    });
  });

  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, [filterObj]);

  useEffect(() => {
    if (formVisible) {
      dispatch.app.setState({
        filterForceHidden: true,
      });
    } else {
      dispatch.app.setState({
        filterForceHidden: false,
      });
    }
  }, [dispatch.app, formVisible]);

  return (
    <>
      <SVCTable />
      {(creatingSvc || viewingSvc) && <SVCItemForm />}
      {(creatingSvcSpec || viewingSvcSpec) && <SVCSpecItemForm />}
      {!isBaseOrg && <SVCBaseSelect />}
      {!isBaseOrg && <SVCSpecBaseSelect />}
    </>
  );
};

export default SVCAdmin;
